import { DAY_COLORS } from "./dayColors";

// compared trips are coloured by slot rather than by day, since two trips
// being compared can share a day colour
export const compareColorForSlot = (slotIndex: number) =>
  DAY_COLORS[slotIndex % DAY_COLORS.length];
